import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { antGrey, runwayColors } from '../styles/globalStyles';
import {
    createAppSettingsAutomationsRouteWithAutomation,
    createAppSettingsRouteWithSettingType,
} from '../../helpers/routeHelpers';
import { SettingType } from '../../types';
import { useHistory } from 'react-router-dom';
import Button from 'antd/lib/button';
import { ThunderboltFilled, SettingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectAutomationById } from '../../selectors/selectors';

interface PullFixesIntoTheReleaseAutomationSettingsBannerProps extends AppComponentProps {
    bannerStyle?: React.CSSProperties;
    bannerText: React.ReactNode;
    autoCherryPickAutomationId: string;
    isAutoCherryPickAutomationEnabled: boolean;
}

const PullFixesIntoTheReleaseAutomationSettingsBanner: React.FC<
    PullFixesIntoTheReleaseAutomationSettingsBannerProps
> = (props: PullFixesIntoTheReleaseAutomationSettingsBannerProps) => {
    const history = useHistory();
    const autoCherryPickAutomation = useSelector((state: RootState) =>
        selectAutomationById(state, props.appId, props.autoCherryPickAutomationId),
    );
    const bannerColor = props.isAutoCherryPickAutomationEnabled ? runwayColors.primary : antGrey.grey6;
    const bannerStyle: React.CSSProperties = {
        ...{
            backgroundColor: `${bannerColor}10`,
            border: `1px solid ${bannerColor}50`,
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            marginTop: 8,
            borderRadius: '5px',
            padding: 8,
            alignItems: 'center',
        },
        ...props.bannerStyle,
    };

    const automationsRoute =
        autoCherryPickAutomation?.id != null ?
            createAppSettingsAutomationsRouteWithAutomation(props.orgId, props.appId, autoCherryPickAutomation.id)
        :   createAppSettingsRouteWithSettingType(props.orgId, props.appId, SettingType.Automations);

    return (
        <div style={bannerStyle}>
            <ThunderboltFilled style={{ marginLeft: 7, marginRight: 15, color: bannerColor }} />
            <div style={{ flex: 1, minWidth: 0 }}>{props.bannerText}</div>
            <Button
                type="link"
                style={{ color: runwayColors.primary, marginLeft: 'auto', alignSelf: 'center' }}
                onClick={() => {
                    history.push(automationsRoute);
                }}
                icon={
                    <SettingOutlined
                        style={{
                            color: runwayColors.primary,
                        }}
                    />
                }
            ></Button>
        </div>
    );
};

export default PullFixesIntoTheReleaseAutomationSettingsBanner;
